export default "__VITE_ASSET__DbsX38v8__"